import { useEffect, useState } from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config.js';

const BreakpointMatch = {
  up: 'up',
  down: 'down',
  only: 'only',
};

const breakpointOrder = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'];

const useCheckBreakpointActive = (bp, match = BreakpointMatch.only) => {
  const [breakpoint, setBreakpoint] = useState('');

  useEffect(() => {
    const fullConfig = resolveConfig(tailwindConfig);
    const { screens } = fullConfig.theme;

    const handleResize = () => {
      if (window.matchMedia(`(max-width: ${screens.xs})`).matches) {
        setBreakpoint('xs');
      } else if (window.matchMedia(`(max-width: ${screens.sm})`).matches) {
        setBreakpoint('sm');
      } else if (window.matchMedia(`(max-width: ${screens.md})`).matches) {
        setBreakpoint('md');
      } else if (window.matchMedia(`(max-width: ${screens.lg})`).matches) {
        setBreakpoint('lg');
      } else if (window.matchMedia(`(max-width: ${screens.xl})`).matches) {
        setBreakpoint('xl');
      } else {
        setBreakpoint('2xl');
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (match === BreakpointMatch.only) {
    return breakpoint === bp;
  } else if (match === BreakpointMatch.up) {
    return breakpointOrder.indexOf(breakpoint) >= breakpointOrder.indexOf(bp);
  } else if (match === BreakpointMatch.down) {
    return breakpointOrder.indexOf(breakpoint) <= breakpointOrder.indexOf(bp);
  }
  return false;
};

export { useCheckBreakpointActive as default, BreakpointMatch };
